<template>
 <div :class="!labelsLoaded ? 'main-container' : '' ">
    <Landing v-if="labelsLoaded"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Landing from './view/Landing.vue'
export default {
  name: 'App',
  components: {
    Landing
  },
  computed: {
    ...mapState(['labelsLoaded'])
  },
  async created () {
    try {
      await this.$store.dispatch('getLabels')
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
